import { IUiRootState } from 'packages/sports/web/app/src/ui-manager/ui-manager.state';

import { IBetslipState } from '../base/store/state';

export interface IDigitalState {
    isSettingsOpened: boolean;
}

export interface IBetslipDigitalState extends IBetslipState {
    digital: IDigitalState;
}

export interface IBetslipDigitalRootState extends IUiRootState {
    betslip: IBetslipDigitalState;
}

export const defaultDigitalState: IDigitalState = {
    isSettingsOpened: false,
};
